/* eslint-disable max-len */

export const page = {
    billing_groups: {
        create_add_members_action: 'Add members',
        create_group: 'Create family group',
        create_group_error: 'Failed to create family group.',
        create_group_success: 'Family group created.',
        create_members_step_description:
            'Choose at least one investor to found this family group. The group inherits their existing fee plans. Investors on different plans can be added afterwards via Manage members.',
        create_members_step_title: 'Add founding investors',
        create_modal_title: 'Create family group',
        create_name_label: 'Family group name',
        create_plans_preview_explanation: 'These are the fee plans this family group will use.',
        create_plans_preview_mismatch:
            "Selected investors are on different fee plans, so they can't found this group together. Remove one to continue, or create the group with one of them and add the other via Manage members.",
        deprecated_warning: 'Contains deprecated fee plan',
        deprecated_warning_message:
            'This family group has one or more subscriptions linked to a deprecated fee plan. Deprecated fee plans can no longer be assigned to new subscriptions but existing subscriptions are unaffected.',
        edit_members_description: 'Select the investors for {group}.',
        edit_members_save_error: 'Failed to update members. Please try again.',
        edit_members_title: 'Manage members',
        group_deleted_empty: 'Family group deleted because it is now empty.',
        heading: 'Family Groups',
        investor_not_plan_compatible:
            'This investor is on different fee plans. Create the group with an investor already on the intended plan, then add this one via Manage members.',
        manage_members_empty_button: 'Manage members',
        members: 'Members',
        members_not_visible: 'Members of this family group are not visible to you.',
        members_updated: 'Members updated.',
        merge_action: 'Merge',
        merge_delete_notice: '{source} is then deleted.',
        merge_description:
            'Merging {source} into another family group moves all its investors to the target group immediately.',
        merge_error: 'Failed to merge family groups.',
        merge_no_active_plans: 'No active plans.',
        merge_plans_adopt_note:
            'Investors moved into {name} switch to these fee plans immediately, and are billed on them from {currentStart}:',
        merge_plans_match: 'Both groups already use these fee plans, so nothing changes for billing:',
        merge_success: 'Family groups merged.',
        merge_target_label: 'Target family group',
        merge_title: 'Merge family groups',
        multi_client: 'Multi-client',
        name_required: 'Family group name cannot be empty.',
        name_update_error: 'Failed to update family group name. Please try again.',
        no_billing_group_selected: 'Select a family group from the list to view its details.',
        no_billing_groups: 'No family groups found.',
        no_matching_billing_groups: 'No family groups match your search.',
        no_members: 'No members in this family group.',
        no_multi_client_billing_groups:
            'No family groups with multiple clients. Switch on Show all to see every group.',
        show_all: 'Show all',
        show_all_description: 'Single-client groups are hidden. Show them to merge, split or see every group.',
        solo_group_created: 'A new family group has been created for {name}.',
        split_action: 'Split',
        split_error: 'Failed to split family group.',
        split_investors_min_one_hint: 'At least one investor must stay in {source}.',
        split_members_step_description_prefix: 'The new group will be called',
        split_members_step_description_suffix: 'and will use the following fee plans:',
        split_members_step_title: 'Select investors to move',
        split_name_step_description:
            "Choose a name for the new family group. You'll then select which investors from {source} to move into it.",
        split_new_group_name: 'New group name',
        split_no_members_hint: 'This group has no investors to move. Add investors first.',
        split_success: 'Family group split. New group {name} created.',
        split_title: 'Split family group'
    },
    bulk_share_allotment: {
        description:
            'Allot shares to multiple holdings at once. Start by selecting the product you wish to allot shares for.',
        heading: 'Bulk Share Allotment',
        PREPARE_HOLDINGS: {
            description:
                'Review the holdings you have selected and enter the number of shares you wish to allot to each holding.',
            heading: 'Prepare Holdings'
        },
        SELECT_HOLDINGS: {
            description: 'Select the holdings you wish to allot shares to.',
            heading: 'Select Holdings'
        }
    },
    client_registrations: {
        description: 'View a list of client registrations.',
        heading: 'Client Registrations'
    },
    clients: {
        description: 'View a list of clients.',
        heading: 'Clients'
    },
    data_entry_subscriptions: {
        add_plan: 'Add fee plan',
        cancel_error: 'Failed to cancel the scheduled subscription change.',
        cancel_error_started:
            'This subscription change cannot be cancelled because it has already started or has no predecessor.',
        cancel_success: 'Scheduled subscription change cancelled.',
        cancel_text: '{planName} ({period}) will no longer be applied, and the group stays on its current plan.',
        cancel_title: 'Cancel scheduled change?',
        change_adviser_plan: 'Change adviser fee plan',
        change_blocked_group_active:
            'Some members of this family group have already submitted their application - ask GrowthInvest to make this change.',
        change_blocked_scheduled: 'Cancel the scheduled change before selecting a new plan.',
        change_blocked_scheduled_adviser:
            'A change is already scheduled - ask GrowthInvest to cancel it before selecting a new plan.',
        change_error_scheduled: 'A fee plan change is already scheduled for this type.',
        change_plan: 'Change',
        change_plan_description:
            'Select a new fee plan for {groupName}. The change takes effect on the next month boundary.',
        change_plan_description_immediate:
            'Select a new fee plan for {groupName}. As the investor has not yet submitted their application, the change takes effect immediately.',
        change_platform_plan: 'Change platform fee plan',
        current_plan: 'Current',
        effective_period: 'Effective period',
        history_heading: 'Subscription history',
        history_label: 'History',
        investors_count: 'Investors',
        investors_count_summary: '{count} investor in group | {count} investors in group',
        keep_current_plan: 'No, keep it',
        load_error: 'Failed to load subscription details.',
        modal_title: '{groupName} subscriptions',
        no_current_plan: '{type} fee plan not set',
        no_current_plan_generic: 'Fee plan not set',
        no_history: 'No subscription history found for this family group.',
        no_type_history: 'No history for this fee plan type.',
        plan_not_set: 'Missing',
        plan_unnamed: 'Unnamed plan',
        rate_plan: 'Rate plan',
        scheduled: 'Scheduled',
        type: 'Type'
    },
    dri_management: {
        description: 'Manage dividend reinvestment plans.',
        heading: 'DRI Management'
    },
    error: {
        browser_incompatible:
            'It appears that you are currently using an outdated version of your browser. To ensure optimal security, we strongly advise updating your browser to benefit from the latest security enhancements.',
        safari_browser_incompatible:
            'The browser and/or browser version you’re running is known to cause issues with our platform due to a defect which was fixed in later versions of Safari. We recommend that you update your browser to a more recent version, or use an alternative such as Chrome, Firefox or Edge.'
    },
    investor_billing_panel: {
        adviser_fee_plan_details_title: 'Adviser Fee Plan Details',
        adviser_fee_plan_label: 'Adviser Fee Plan',
        adviser_filter_all: 'All Adviser Firms',
        adviser_filter_label: 'Filter by Adviser Firm',
        application_form_heading:
            'Would you like to show the ongoing adviser fees on the GrowthInvest account application form?',
        application_form_locked:
            'To change a fee plan, cancel a scheduled change, or change facilitated fees, contact GrowthInvest.',
        application_form_option_agreed_externally:
            'All ongoing adviser fees and charges have been agreed in advance and are intentionally not represented on the GrowthInvest account application form.',
        application_form_option_fee_plan:
            'Ongoing adviser fees will be displayed in the GrowthInvest application form based on the fee plan detailed above.',
        application_form_required: 'Required before the application form is sent.',
        application_form_save_error: 'Your selection could not be saved. Please try again.',
        application_form_save_success_agreed_externally: 'Application form updated: fees agreed externally.',
        application_form_save_success_fee_plan: 'Application form updated: fees shown per the fee plan.',
        billing_group_contact_gi:
            'To create a Family Group for existing clients, or to amend an existing Family Group, please contact GrowthInvest client services team on',
        billing_group_label: 'Family Group',
        description: 'Manage billing settings for {name}.',
        empty: 'No family group or subscriptions found for this adviser relationship.',
        facilitated_fees_collected:
            'We will collect these fees on behalf of your adviser or financial intermediary from your account on a monthly basis.',
        facilitated_fees_disabled: 'Disabled',
        facilitated_fees_enabled: 'Enabled',
        facilitated_fees_illustration_only:
            'Your intermediary or financial adviser has elected to not ask us to collect their fees from you, and the information is used for fee illustrations only.',
        facilitated_fees_label:
            'Would you like GrowthInvest to facilitate the payment of ongoing adviser fees via the platform?',
        facilitated_fees_proposal_hint:
            'New proposals for this client take their ongoing adviser fee collection from this setting.',
        facilitated_fees_save_success_disabled: 'Facilitated fees disabled.',
        facilitated_fees_save_success_enabled: 'Facilitated fees enabled.',
        fee_percentage_save_success: 'Fee percentage updated to {percent}%.',
        fee_plan_details_title: 'Fee plan details',
        heading: 'Billing',
        inc_vat: 'inc VAT',
        load_error: 'Failed to load family group and subscriptions.',
        load_forbidden: 'Fees and Charges information is restricted to the Account Owner.',
        manage_billing_group: 'Manage family group',
        manage_billing_groups: 'Manage family groups',
        multi_investor_callout_text:
            'This family group includes multiple investors, and changes to fee plans may affect all members of the group.',
        platform_fee_plan_details_title: 'Platform Fee Plan Details',
        platform_fee_plan_label: 'Platform Fee Plan',
        platform_fees_label: 'GrowthInvest Charges',
        subscription_period_ongoing: 'ongoing'
    },
    investor_billing_subscriptions_panel: {
        confirm_fee_percentage_text_immediate:
            '{percent}% will become the {planType} rate for {groupName} immediately, as the investor has not yet submitted their application.',
        confirm_fee_plan_shared: 'This changes the fee plan for every investor in {groupName}.',
        confirm_fee_plan_text:
            'The current {planType} fee plan for {groupName} will end on {currentEnd}. {planName} will apply from {nextStart}.',
        confirm_fee_plan_text_immediate:
            '{planName} will become the {planType} fee plan for {groupName} immediately, as the investor has not yet submitted their application.',
        confirm_fee_plan_title: 'Change {planType}?',
        plan_type_adviser: 'Adviser Fee Plan',
        plan_type_platform: 'Platform Fee Plan',
        save_error: 'Failed to update billing settings.',
        save_success_fee_plan: 'Fee plan change scheduled from {nextStart}.',
        save_success_fee_plan_immediate: 'Fee plan changed.',
        scheduled_fee_plan: 'Changing to {planName} on {nextStart}.',
        selected_billing_group: 'the selected family group',
        selected_fee_plan: 'the selected fee plan'
    },
    investor_portfolio_restricted: {
        adviser_notice:
            "Our Asset Servicing team are currently working to update your client's account. During this time, you may see changes to investment values, cash balances and, if applicable, additional assets being onboarded. If you have any queries, please contact our team.",
        heading: 'This page will be available soon',
        investor_notice:
            'Our Asset Servicing team are currently working to update your account. During this time, you may see changes to investment values, cash balances and, if applicable, additional assets being onboarded. If you have any queries, please contact our team.'
    },
    investor_visibility_panel: {
        adviser_filter_all: 'All Adviser Firms',
        adviser_filter_label: 'Filter by Adviser Firm',
        description_off:
            'Users listed here will be able to view the profile and investment data for {name} when visibility restrictions for the organisation are enabled.',
        description_on:
            'Users listed here are able to view the profile and investment data for {name} on the platform.',
        empty: 'No visibility users found for this investor.',
        groups_column: 'Group(s)',
        heading_off: 'Who would be able to see this investor',
        heading_on: 'Who can see this investor',
        load_error: 'Failed to load investor visibility.',
        reason_column: 'Reason',
        user_column: 'User'
    },
    library: {
        description: 'View a list of documents.',
        heading: 'Library'
    },
    portfolio_dashboard: {
        description: 'View a summary of your portfolio.',
        heading: 'Dashboard'
    },
    portfolio_detail: {
        eis_seis: {
            description: 'View EIS and SEIS fund investments in your portfolio.',
            heading: 'EIS and SEIS Funds'
        },
        heading: 'Portfolio Detail',
        iht: {
            description: 'View IHT and Estate Planning Services investments in your portfolio.',
            heading: 'IHT and Estate Planning'
        },
        pmi_closed: {
            description: 'View Private Market investments in your portfolio.',
            heading: 'Private Market (Closed-ended)'
        },
        pmi_open: {
            description: 'View Private Market investments in your portfolio.',
            heading: 'Private Market (Open-ended/Other)',
            sheet_name: 'Private Market (Open-ended)'
        },
        single_company: {
            description: 'View Single Company investments in your portfolio.',
            heading: 'Single Company'
        },
        summary: {
            description: 'View a summary of your portfolio.',
            heading: 'Summary'
        },
        vct: {
            description: 'View Venture Capital Trust investments in your portfolio.',
            heading: 'Venture Capital Trusts'
        }
    },
    proposal: {
        special_event: {
            PROPOSAL_APPLICATION_SIGNED: {
                description: 'Provide the date when the application was signed:',
                title: 'Proposal Application Signed'
            },
            PROPOSAL_FUNDS_TRANSFERRED: {
                description: 'Provide the date when the funds were transferred:',
                title: 'Funds Transferred'
            }
        }
    },
    proposals: {
        description: 'Proposals are a way to keep track of potential investments.',
        heading: 'Proposals'
    },
    rate_plan: {
        add_tier: 'Add tier',
        adviser_account_billing_selection_help:
            'Please select the relevant Fee Plan for the client below. If the client is being added to an existing Family Group, please select only that family group.',
        adviser_account_fee_percentage_help:
            'Please set the ongoing adviser fees as a percentage of overall portfolio.',
        adviser_rate_plan: 'Adviser ongoing fee plan',
        annual_fee: 'Annual fee',
        band_charged_on: 'Charged on {amount}',
        band_minimum: 'Min {amount}',
        band_minimum_applied: 'Band minimum {amount} applied',
        band_product_charge: 'on {charged} = {fee}',
        band_range: '{from} to {to}',
        bands: 'Bands',
        billing_group: 'Family group',
        billing_group_members: 'Members',
        calculation_effective_rate: 'Effective rate',
        calculation_maximum: 'Maximum',
        calculation_minimum: 'Minimum',
        calculation_rate: 'Rate',
        calculation_type: 'Calculation type',
        calculations: 'Calculations',
        client_aua: 'Client AUA',
        client_quantity: 'Client quantity',
        create_client_billing_selection_help:
            'Select an ongoing adviser fee plan for your client, or if they are related to an existing investor who is already part of a Family Group, simply select the family group you wish to add them to, and the correct adviser fee plan will be applied automatically.',
        create_selection_help:
            'Choose an existing family group to inherit its fee plans, or leave family group empty to create a new group and select individual platform and adviser ongoing fee plans below.',
        current_adviser_subscription: 'Current adviser subscription',
        current_platform_subscription: 'Current platform subscription',
        default: 'Default plan',
        entry_eis_rate: 'EIS/SEIS',
        entry_from: 'From',
        entry_from_amount: 'From {amount}',
        entry_iht_rate: 'IHT',
        entry_minimum_fee: 'Minimum fee',
        entry_other_rate: 'Other',
        entry_pmi_rate: 'PMI',
        entry_rate: 'Rate',
        entry_rate_per_unit: 'Rate per unit',
        entry_to: 'To',
        entry_to_amount: 'Up to {amount}',
        entry_to_infinity: '∞',
        entry_to_infinity_label: 'No upper limit',
        entry_to_must_exceed_from: 'To must be greater than From',
        entry_vct_rate: 'VCT',
        fee_tiers: 'Fee tiers',
        fee_tiers_description: 'Define calculation type and the bands used to calculate the ongoing fee.',
        lifecycle_activate_body: 'Makes this fee plan available for new subscriptions. Fields can no longer be edited.',
        lifecycle_activated: 'activated',
        lifecycle_deactivate_blocked_default:
            'Cannot deactivate the default fee plan. Set another plan as default first.',
        lifecycle_deactivate_blocked_subscriptions: 'Cannot unpublish a fee plan that has subscriptions linked to it.',
        lifecycle_deactivate_body:
            'Returns this active fee plan to draft so you can make changes. This is only allowed if the plan has no subscriptions.',
        lifecycle_deactivated: 'deactivated',
        lifecycle_delete_body: 'Permanently removes this draft fee plan. This fails if the plan has any subscriptions.',
        lifecycle_deleted: 'deleted',
        lifecycle_deprecate_blocked_default:
            'Cannot deprecate the default fee plan. Set another plan as default first.',
        lifecycle_deprecate_blocked_only_active:
            'Cannot deprecate the only active fee plan of this type for this adviser firm.',
        lifecycle_deprecate_body: 'Retires this fee plan for new subscriptions. Existing subscriptions are unaffected.',
        lifecycle_deprecated: 'deprecated',
        lifecycle_endpoint_unavailable: 'This action could not be completed right now. Please try again later.',
        lifecycle_set_as_default: 'set as default',
        maximum_fee: 'Maximum annual fee',
        maximum_fee_help: 'Maximum annual fee the client will be charged.',
        min_max_application: 'Application of min/max fees',
        minimum_aua_threshold: 'Minimum AUA threshold',
        minimum_aua_threshold_help: 'Clients must have at least this value of assets on platform to use this fee plan.',
        minimum_fee: 'Minimum annual fee',
        minimum_fee_help: 'Minimum annual fee the client will be charged.',
        option_a_billing_group: 'Join an existing family group',
        option_b_rate_plans: 'Select adviser ongoing fee plan',
        per_product_rates: 'Per-product rates',
        platform_rate_plan: 'Platform fee plan',
        rate_highlighted: 'Highlighted above',
        read_only_active:
            'This fee plan is active and cannot be edited here. Deactivate it to make changes - only allowed if it has no subscriptions, and is not the default fee plan.',
        read_only_deprecated: 'This fee plan is deprecated and cannot be edited.',
        read_only_not_draft: 'Only draft fee plans can be edited.',
        section_fees: 'Fees',
        section_fees_description:
            'Optional AUA eligibility and annual fee caps. Application options appear when a fee is set.',
        section_identity: 'Plan details',
        section_identity_description: 'Who this plan belongs to and how it is labelled in the system.',
        section_standing_charge: 'Standing charge',
        section_standing_charge_description: 'Optional fixed charge applied in addition to the tiered rates below.',
        split_rates: 'Split?',
        status: 'Status',
        submit_disabled_active:
            'This fee plan is active. Deactivate it to make changes - only allowed if it has no subscriptions, and is not the default fee plan.',
        subscription_period: 'Effective period',
        subscriptions: 'Subscriptions',
        surcharge: 'Standing charge',
        surcharge_application: 'Standing charge calculation',
        surcharge_application_help: 'Whether the standing charge is applied before or after minimum and maximum fees.',
        surcharge_calculation_label: '{label} calculation',
        surcharge_help: 'Fixed additional fee on top of the per unit fees applied below.',
        surcharge_label: 'Standing charge label',
        surcharge_none: 'None',
        tier_application: 'Tier application',
        title: 'Rate plans',
        type: 'Fee plan type',
        type_fee_plan: '{type} fee plan',
        value_checker: 'Value checker',
        value_checker_help_aua: 'Enter a client AUA to preview the annual fee from this plan.',
        value_checker_help_breakdown_aua:
            "This plan charges a different rate per product. Enter the client's AUA in each product to preview the annual fee.",
        value_checker_help_breakdown_quantity:
            "This plan charges a different rate per product. Enter the client's quantity in each product to preview the annual fee.",
        value_checker_help_quantity: 'Enter a client quantity to preview the annual fee from this plan.',
        value_checker_products_aua: 'AUA by product',
        value_checker_products_quantity: 'Quantity by product'
    },
    remote_application_action: {
        DELETE_REMOTE_APPLICATION: {
            warning:
                'Deleting this remote application will remove all trace of this application ever having existed in the system. This should only be used when an application has been entered in error.'
        }
    },
    reports: {
        adviser_documents_activity_description:
            'This report provides details of actions taken on documents in the platform library related to your organisation.',
        adviser_marketing_activity_description:
            'This report provides details of browsing activity on the platform carried out by users in your organisation. This includes viewing and updating items like offers, shortlists and proposals.',
        adviser_security_activity_description:
            'This report provides details of security events related to users in your organisation. These include logins, password resets and key account changes.',
        heading: 'Reports',
        investor_documents_activity_description:
            'This report provides details of actions taken on documents in the platform library associated with your clients.',
        investor_flow_activity_description: 'This report provides step-by-step information on the proposal workflow.',
        investor_marketing_activity_description:
            'This report provides details of browsing activity on the platform carried out by your clients. This includes viewing and updating items like offers, shortlists and proposals.',
        investor_security_activity_description:
            'This report provides details of security events related to your clients. These include logins, password resets and key account changes',
        investor_users_description:
            'Lists users on investor organisations you can access, including whether they can log in and when they last logged in.',
        pending_applications: {
            alert_text:
                "This report shows investors which have applied for an investment account, but have no 'Investment account authorised' date set. Once the authorised date is set, the account will drop off this report."
        },
        tax_year: {
            alert_text:
                'Tax relief amounts calculated by this report are based on the maximum tax relief available for the investments and does not take into account the personal circumstances of the investor. The tax status of each investment is taken as reported. Future actions either by the investor or by the investee company may affect the tax status and tax relief which can be claimed.'
        }
    },
    settings: {
        bank_accounts: {
            authorised_with_no_bank_account_notice:
                'No bank account details were provided during the application process. You will not be able to withdraw any funds from your account until your bank details have been provided and verified.',
            authorised_with_no_bank_account_notice_title:
                'Important Notice: Bank Account Details Required for Fund Withdrawal',
            deferral_checkbox_label:
                'I would like to open my GrowthInvest account without a linked bank account, and I understand that I will need to add this at a later stage.',
            james_brearley_account_name: 'James Brearley & Sons Ltd',
            james_brearley_account_number: '10 49 16 89',
            james_brearley_address:
                'Online Services Team (GrowthInvest), James Brearley & Sons, Walpole House, Unit 2 Burton Road, Blackpool, FY4 4NW',
            james_brearley_address_label:
                'Cheques should be made payable to "James Brearley & Sons Ltd" and sent to the following address with a cover letter stating your name and client number.',
            james_brearley_bank_name: 'Royal Bank of Scotland',
            james_brearley_description:
                'This account is to be used for making investment in any listed products. This may include VCT & AIM products and ISA transfers only. You must use your James Brearley Client Number followed by your surname as payment reference for Online Bank Transfers to ensure funds are allocated correctly. If you do not, this will cause unnecessary delays in cash allocation.',
            james_brearley_description_warning:
                'If you do not know your James Brearley Client Number (N.B. this is different from your GrowthInvest Client reference and account numbers), please ask your intermediary or email clientservices@growthinvest.com before making payment',
            james_brearley_heading: 'James Brearley GrowthInvest Bank Account Details',
            james_brearley_sort_code: '16 14 12',
            not_authorised_with_no_bank_account_notice: 'Only the account owner can manage their bank accounts.',
            subtitle:
                'Please provide details of the bank account to which any distributions, for example dividends, should be paid. This should usually be in the name of the bank account holder. Please note that additional verification checks may be required, including a copy of a bank statement to confirm details in advance of the transfer of any funds.',
            transaction_reference_description: 'You must use a reference number when transferring funds.',
            transaction_reference_prefix: 'Your reference for this account is:',
            transfer_details_title: 'Transfer funds to your GrowthInvest account',
            woodside_account_name: 'WCSL GrowthInvest Client Account',
            woodside_account_number: '10 40 96 65',
            woodside_address:
                "GrowthInvest Team, Woodside Corporate Services Ltd, 1st Floor, 12-14 Mason's Avenue, London, EC2V 5BT",
            woodside_address_label:
                'Cheques should be made payable to "WCSL GrowthInvest Client Account" and sent to the following address:',
            woodside_bank_name: 'Bank of Scotland',
            woodside_description:
                'This account is to be used when making an investment in any unlisted (SEIS, EIS, IHT/BR excl. AIM) and private equity products only. Any money deposited will be shown as a cash balance on your account. To ensure funds are allocated correctly and in a timely manner, please use the reference stated below when making online payments.',
            woodside_heading: 'Woodside GrowthInvest Bank Account Details',
            woodside_sort_code: '80 20 00'
        },
        billing: {
            auto_payments_description:
                'Automatic payments are used to periodically withdraw excess cash and to settle fees and charges.',
            fee_documents_description:
                'These documents offer detailed information to help you understand the fees and charges associated with the services delivered by the intermediary and the platform.',
            fee_documents_empty: 'There are currently no documents available to download, please come back later.',
            fee_documents_none: 'No documents',
            gi_fee_description:
                'GrowthInvest Platform fees and charges are typically applied as a percentage of your overall portfolio value. A more detailed breakdown of the annual fee is available by clicking on the Fee plan name above. For a full breakdown of all GrowthInvest fees and charges please see the Platform Fees and Charges document linked on this page.',
            intermediary_fee_description:
                'GrowthInvest can facilitate the payment of fees to your adviser or financial intermediary if requested. Please EITHER select Option A, and enter a % or a £ amount for adviser fees to be applied OR Select Option B, and check the box below to indicate that any adviser fees and charges have been agreed in advance. To change these fees please contact our Client Services team.',
            intermediary_fee_description_advanced:
                'GrowthInvest can facilitate the payment of fees to your adviser or financial intermediary if requested. To change these fees please contact our Client Services team.',
            intermediary_fee_short_description:
                'Please EITHER select Option A, and enter a % or a £ amount for adviser fees to be applied OR Select Option B, and check the box below to indicate that any adviser fees and charges have been agreed in advance.',
            intermediary_fee_short_description_advanced:
                'To change these fees please contact our Client Services team.',
            subtitle:
                'Please review all fees and charges detailed below. All the latest GrowthInvest account and administration charges are available on the Fees and Charges document.'
        },
        branding: {
            avatar: 'Also known as the "Profile Picture", your brand avatar is a smaller version of your brand logo that represents your brand on the platform. It is typically displayed alongside your brand name and serves as a visual identifier for you organisation.',
            background:
                "The background image should be a high-quality JPG file that captures the essence of the company's brand identity. It should be visually appealing and non-distracting, ensuring that it does not interfere with the client self-registration process.",
            colours:
                'The colours you choose should be consistent with your brand and should pass the recommended contrast accessibility test to ensure that people with moderately low vision can use the platform.',
            favicon:
                "The favicon appears in the web browser's address bar, next to the page title, and on bookmarks or tabs. The purpose of the favicon is to provide a visual representation of the platform in the browser's interface, making it easier for users to identify.",
            logo: "Before you update your platform logo, it's important to consider the impact this change may have on your brand identity and recognition. Your logo is often the first thing that clients see so it's essential to ensure it's either a high-quality transparent PNG or an SVG.",
            pdf_cover:
                'The PDF cover image should be a high-quality JPG file. The cover image will be displayed on the first page of both the portrait and landscape PDF exports from the platform. The images you upload must be A4 size (21cm x 29.7cm) or have a ratio of 1:1.41 to prevent distortion.',
            preview:
                'The preview will help to get a feel for what it will look like when you apply the changes to the platform branding.'
        },
        communication: {
            growthinvest_marketing_updates_tooltip:
                'Clients and users can opt in to receiving direct GrowthInvest updates on relevant product information, and newsletters about the company aimed at our clients',
            growthinvest_technical_regulatory_updates_tooltip:
                'This is a mandatory selection for all users, and is used only for required communications'
        },
        external_users: {
            heading: 'External Users'
        },
        fee_plans: {
            activate_plan: 'Activate this fee plan',
            adviser_fee_plans: 'Adviser fee plans',
            already_default: 'This is the default plan',
            band: 'Band',
            band_count: '{count} bands',
            calculation_type_quantity_description: 'Calculated from unit quantity.',
            calculation_type_value_description: 'Calculated from asset value.',
            create_error: 'Failed to create fee plan.',
            create_requires_calculation_type: 'Choose a calculation type before creating a fee plan.',
            create_requires_name: 'You must enter a name before creating a fee plan.',
            create_requires_tiers: 'Set fee tiers before creating a fee plan.',
            create_requires_type: 'Choose Adviser or Platform before creating a fee plan.',
            deactivate_plan: 'Deactivate this fee plan',
            delete_plan: 'Delete this fee plan',
            deprecated_plan_readonly: 'Deprecated fee plans cannot be changed',
            discard_draft_tooltip: 'Discard this unsaved fee plan.',
            draft_plan: 'Draft fee plan',
            entries_empty_button: 'Set fee tiers',
            entries_modal_description: 'Define calculation type and the bands used to calculate the ongoing fee.',
            entries_modal_title: 'Fee tiers',
            entries_save_error: 'Failed to save fee tiers.',
            entry_tier: 'Tier {number}',
            fee_tiers_description: 'Bands used to calculate the ongoing fee.',
            fees_description: 'How the ongoing fee is calculated.',
            limits_description: 'Fees, thresholds, and adjustments that bound this plan.',
            limits_empty_button: 'Set limits',
            limits_modal_description: 'Optional AUA eligibility, annual fee caps, and standing charge.',
            limits_modal_title: 'Limits & adjustments',
            limits_save_error: 'Failed to save limits and adjustments.',
            limits_title: 'Limits & adjustments',
            new_fee_plan_for: 'New fee plan for {organisation}',
            no_attributes: 'No limits or adjustments on this plan.',
            no_entries: 'This fee plan has no fee tiers.',
            no_fee_plan_selected: 'Select a fee plan from the list to view its details.',
            no_fee_plans: 'No fee plans',
            no_fee_plans_of_type: 'There are no fee plans of this type',
            no_matching_fee_plans: 'No fee plans match your filters',
            platform_fee_plans: 'Platform fee plans',
            save_draft: 'Save fee plan',
            save_draft_check_name: 'Name',
            save_draft_check_tiers: 'Fee tiers',
            save_draft_check_type: 'Type',
            save_draft_disabled_intro: 'Before you can save this fee plan:',
            save_draft_requires_name: 'Enter a name',
            save_draft_requires_tiers: 'Set fee tiers',
            save_draft_requires_type: 'Choose Adviser or Platform',
            save_draft_tooltip: 'Save this fee plan.',
            set_as_default: 'Set as default',
            set_as_default_body:
                'Sets this plan as the default {type} fee plan for the firm. New subscriptions of this type will use it unless another plan is chosen.',
            set_as_default_replaces: 'This replaces {name} as the default.',
            set_default_active_only: 'Only active fee plans can be set as default',
            type_adviser_description: 'Charged as an adviser fee.',
            type_platform_description: 'Charged as a platform fee.'
        },
        financial: {
            fees_charges_subtitle: 'Last 12 months of fees and charges statements.',
            fees_charges_title: 'Fees and Charges'
        },
        platform_configuration: {
            ADVANCED_RATE_PLANS: 'Advanced fee plans',
            ADVANCED_VISIBILITY_GROUPS: 'Advanced visibility groups',
            adviser_fee_reserve_duration: 'Adviser fee reserve',
            adviser_fees_agreed_externally_default:
                'Would you like to show the ongoing adviser fees on the GrowthInvest account application form?',
            allowed_solve_amount_for: 'Proposal calculation types',
            apply_vat_to_initial_adviser_fees: 'VAT applied to initial adviser fees',
            apply_vat_to_initial_adviser_fees_no: 'No, we do not charge VAT on initial adviser fees',
            apply_vat_to_initial_adviser_fees_yes: 'Yes, we charge VAT on initial adviser fees',
            apply_vat_to_ongoing_adviser_fees: 'VAT applied to ongoing adviser fees',
            apply_vat_to_ongoing_adviser_fees_no: 'No, we do not charge VAT on ongoing adviser fees',
            apply_vat_to_ongoing_adviser_fees_yes: 'Yes, we charge VAT on ongoing adviser fees',
            BASIC_VISIBILITY_GROUPS: 'Basic visibility groups',
            default_initial_adviser_fee_collection: 'Initial adviser fee collection',
            default_platform_fee: 'Default platform fee',
            description: {
                ADVANCED_RATE_PLANS: 'Manage family groups, tiered fee plans, and fee plan subscriptions.',
                ADVANCED_VISIBILITY_GROUPS: 'Adds parent and child inheritance to visibility groups.',
                adviser_fee_reserve_duration:
                    'Duration of upfront annual adviser fees required. Applies to existing clients unless changed for that client.',
                adviser_fees_agreed_externally_default:
                    'Whether a new client application form displays adviser fees or not.',
                allowed_solve_amount_for: "Which calculation types this firm's proposals can use.",
                apply_vat_to_initial_adviser_fees: "Whether the firm's initial adviser fees include VAT.",
                apply_vat_to_ongoing_adviser_fees: "Whether the firm's ongoing adviser fees include VAT.",
                BASIC_VISIBILITY_GROUPS: 'Limit which clients an adviser firm user can see, by primary contact.',
                default_initial_adviser_fee_collection:
                    "How initial adviser fees are collected on new proposals. With no default, it must be chosen on each proposal. Ongoing adviser fee collection follows each client's facilitated fees setting.",
                default_platform_fee: 'Platform fee set for new clients who register through the firm.',
                disable_cobranded_reports: "Generated PDF reports use GrowthInvest branding, not the firm's.",
                disable_investor_welcome_page: 'Do not display the introduction tab on the client page.',
                facilitate_adviser_fees_default:
                    "Whether new clients start with ongoing adviser fees collected by the platform. Each client's own setting decides ongoing collection on their new proposals.",
                platform_fee_reserve_duration:
                    'Duration of upfront annual platform fees required. Applies to existing clients unless changed for that client.'
            },
            disable_cobranded_reports: 'Disable co-branded reports',
            disable_investor_welcome_page: 'Disable client welcome page',
            facilitate_adviser_fees_default:
                'Would you like GrowthInvest to facilitate the payment of ongoing adviser fees via the platform?',
            feature_flags_subtitle:
                'Settings that control access to specific platform functionality by enabling or disabling features at a firm level.',
            feature_flags_title: 'Feature flags',
            firm_defaults_subtitle:
                'Firm defaults can be configured to guide staff towards preferred options, while still providing access to alternative selections when needed.',
            firm_defaults_title: 'Firm defaults',
            firm_settings_subtitle:
                'Firm settings are mandatory controls applied firm-wide that restrict access to specific features or options.',
            firm_settings_title: 'Firm settings',
            platform_fee_reserve_duration: 'Platform fee reserve',
            remove_advanced_visibility_groups_confirm: 'Turn off Advanced',
            remove_advanced_visibility_groups_keep: 'Keep Advanced',
            remove_advanced_visibility_groups_text:
                'Turning off Advanced Visibility Groups permanently removes all parent and child relationships between visibility groups.',
            remove_advanced_visibility_groups_title: 'Turn off Advanced Visibility Groups?',
            solve_amount_for_last_offered: 'An adviser must offer at least one calculation type.'
        },
        profile: {
            contact_details_heading: 'Contact Details',
            investor_status_heading: 'Investor Status',
            nationality_heading: 'Nationality and Domicile',
            personal_details_heading: 'Personal Details',
            regulatory_details_heading: 'Regulatory Details'
        },
        restricted_panels: {
            create_requires_offer: 'You must select at least one offer before creating a panel.',
            delete_text: 'This action will permanently delete {panel}.',
            delete_title: 'Delete Panel',
            deletion_disabled_tooltip: 'Default panel cannot be deleted.',
            deletion_tooltip: 'Delete {panel}.',
            new_panel_for: 'New panel for {organisation}',
            no_panel_available:
                'Restricted panels control which offers are available to users in {organisation}. Get started by creating a panel.',
            offer_type: {
                FUND: 'Fund',
                SINGLE_COMPANY: 'Single Company'
            },
            offers_description: 'Offers available in {panel}.',
            offers_empty_text: 'No offers have been added to {panel}.',
            offers_load_error: 'We could not load offers right now. Please try again.',
            offers_title: 'Offers',
            save_error: 'Failed to save panel offers.',
            select_offers_description: 'Choose the offers for {panel}.',
            select_offers_title: 'Select Offers'
        },
        users: {
            heading: 'Users'
        },
        users_visibility_groups_bulk: {
            grants_modal_description: 'Select every visibility group for which {name} should be a viewer.',
            grants_modal_title: 'Manage viewer groups',
            primary_contacts_modal_description:
                'Select every visibility group for which {name} should be a primary contact.',
            primary_contacts_modal_title: 'Manage primary contact groups',
            save_error: 'Could not save visibility group assignments. Please try again.'
        },
        visibility_groups: {
            active_with_disabled_visibility_restrictions:
                'Visibility Group is active - Restrictions will apply when Visibility Restrictions are enabled',
            active_with_enabled_visibility_restrictions: 'Visibility Group is active',
            children_empty_button: 'Select child visibility groups',
            children_empty_max_depth_text:
                'This group is at the lowest hierarchy level. Child visibility groups are not available.',
            children_empty_text: 'No child visibility groups have been added to {visibility_group}.',
            create_error: 'Failed to create visibility group.',
            create_requires_name: 'You must enter a name before creating a visibility group.',
            delete_affected_users_warning: 'will lose visibility of investors from this visibility group.',
            delete_error: 'Failed to delete visibility group.',
            delete_requires_uncouple_children_error:
                'You cannot delete {visibility_group} whilst it has child visibility groups. Remove child relationships first, then try again.',
            delete_text: 'This action will permanently delete {visibility_group}.',
            delete_title: 'Delete Visibility Group',
            deletion_disabled_tooltip: 'You can delete {visibility_group} when it is deactivated.',
            deletion_has_children_tooltip:
                'You cannot delete {visibility_group} whilst it has child visibility groups. Remove child relationships first.',
            deletion_tooltip: 'Delete {visibility_group}.',
            disable_affected_users_warning:
                'will have unrestricted visibility of all investors (including those they are not the primary contact for).',
            disable_text: 'This change will remove all visibility restrictions from users in your firm.',
            disable_title: 'Disable Visibility Restrictions',
            discard_draft_tooltip: 'Discard this unsaved visibility group.',
            empty_items_text: 'No visibility groups found.',
            enable_affected_users_warning: 'will have visibility restrictions applied.',
            enable_text: 'This change will restrict the visibility of users in your firm.',
            enable_title: 'Enable Visibility Restrictions',
            enablement_disabled_tooltip: 'You can activate/deactivate {visibility_group} when it has been named.',
            export_as_pdf: 'Download full audit report in PDF format',
            export_as_xlsx: 'Download full audit report in XLSX format',
            export_error: 'Failed to export visibility groups audit report.',
            grants_description: 'Users who have been granted visibility of the investors in {visibility_group}.',
            grants_empty_button: 'Select viewers',
            grants_empty_text: 'No users have been granted visibility of {visibility_group}.',
            grants_modal_description:
                'Select the users who should be granted visibility of the investors in {visibility_group}.',
            grants_modal_title: 'Select Viewers',
            grants_save_error: 'Failed to save viewers.',
            grants_title: 'Who can view this Visibility Group',
            inactive: 'Visibility Group is inactive',
            map_close_fullscreen: 'Close fullscreen view',
            map_description: 'Visual hierarchy of inheritance for {visibility_group}.',
            map_description_overview: 'Visual hierarchy of inheritance across all visibility groups.',
            map_fullscreen: 'View hierarchy in fullscreen',
            map_recentre: 'Re-centre',
            map_title: 'Hierarchy',
            new_visibility_group_for: 'New visibility group for {organisation}',
            no_items: 'No items',
            no_visibility_group_available:
                'Restrict the visibility of users in {organisation} to investors derived from primary contacts in the visibility groups they have been granted access to view. Get started by creating a visibility group.',
            no_visibility_group_selected: 'Select a visibility group from the list to view its details.',
            primary_contacts_description: 'Users who are the primary contacts for investors in {visibility_group}.',
            primary_contacts_empty_button: 'Select primary contacts',
            primary_contacts_empty_text: 'No primary contacts have been selected for {visibility_group}.',
            primary_contacts_modal_description:
                'Select the users who are primary contacts for investors in {visibility_group}.',
            primary_contacts_modal_title: 'Select Primary Contacts',
            primary_contacts_save_error: 'Failed to save primary contacts.',
            primary_contacts_title: 'Primary Contacts',
            relationships_cycle_error:
                'This change would create a cycle in the visibility group hierarchy. Remove descendant selections and try again.',
            relationships_description: 'Which visibility groups are also included in {visibility_group}?',
            relationships_max_depth_error:
                'This change would exceed the maximum of {max_depth} hierarchy levels. Remove child visibility groups from the selection or shorten the branch you are moving before trying again.',
            relationships_max_depth_tooltip:
                'This visibility group cannot be added as a child here because it would exceed the maximum of {max_depth} hierarchy levels. Remove its child groups first, or reparent in smaller steps.',
            relationships_modal_add_child: 'Add {name} as a child',
            relationships_modal_available: 'Available',
            relationships_modal_empty_selected: 'No child visibility groups selected.',
            relationships_modal_helper:
                'Choose direct child visibility groups for {visibility_group}. Each group can only have one parent and cannot be assigned to itself or an ancestor. Assigning a group here removes it from any other parent.',
            relationships_modal_no_search_results: 'No visibility groups match your search.',
            relationships_modal_none_available: 'No other visibility groups can be added here.',
            relationships_modal_remove_child: 'Remove {name} from children',
            relationships_modal_selected: 'Selected',
            relationships_modal_title: 'Select child visibility groups',
            relationships_save_error: 'Failed to save visibility group relationships.',
            relationships_title: 'Relationships',
            restrictions_off_text:
                'Clients are visible to all users. Enable visibility restrictions to restrict client visibility to primary contact and visibility group viewers only.',
            restrictions_off_title: 'Visibility Restrictions are DISABLED',
            restrictions_on_text:
                'Users in your firm will only see investors they are the primary contact for, unless you grant them access to view additional visibility groups. Disable visibility restrictions to allow users in your firm to see all investors.',
            restrictions_on_title: 'Visibility Restrictions are ENABLED'
        }
    },
    shortlists: {
        description: 'Shortlists are a way to keep track of investments that you are interested in.',
        heading: 'Shortlists'
    },
    transaction_action: {
        CHANGE_AMOUNTS_AND_SHARES: {
            PURCHASE:
                'Update the amounts for this purchase. Note that this will update the initial investment amounts on the holding.',
            SALE: 'Update the amounts for this sale. The holding disposition status will be updated to reflect the number of shares sold in this transaction and will be opened/closed accordingly. Note that if future sales close this position, the number of shares you can sell will be limited by those transactions. If necessary, delete them first.'
        },
        CHANGE_FUND_AMOUNT:
            'Enter a new initial investment amount for this fund investment. This will update the tranche and the transactions to match.',
        CHANGE_PRODUCT:
            'Select a new product for this transaction. This will update the holding and all related transactions (e.g. any related sell or dividend transactions).',
        CHANGE_SALE_AMOUNT: 'Update the amount of this transaction.',
        DELETE_TRANSACTION: {
            relationship_warning:
                'Deleting this transaction will remove all transactions, holdings and, where appropriate, tranches related to this transaction. This potentially has a wide-ranging effect and you should proceed with EXTREME CAUTION.',
            warning:
                'Deleting this transaction will remove all trace of this transaction ever having existed in the system. This should only be used when a transaction has been entered in error.'
        },
        TOGGLE_ON_OFF_PLATFORM: {
            OTHER: 'Change the on/off platform status.',
            PURCHASE:
                'Change the on/off platform status. Note that this will update the position to reflect the correct platform status.'
        }
    },
    transactions: {
        description: 'View a list of transactions.',
        heading: 'Transactions'
    },
    users_visibility_panel: {
        configure_cta: 'Configure visibility groups',
        contact_investors_list_title: 'Primary Contact Investors',
        description: 'Review visibility group coverage and effective investor visibility for {name}.',
        description_default: 'Review visibility group coverage and effective investor visibility.',
        effective_investors_list_title: 'Effective Investors',
        granted_investors_list_title: 'Viewer Investors',
        heading: 'Visibility for {name}',
        heading_default: 'Visibility',
        load_error: 'Failed to load visibility groups for this user.',
        more_investors: '+ {count} more...',
        no_contact_investors: 'No Primary Contact investors found for this firm.',
        no_effective_investors: 'No effective investors found for this firm.',
        no_granted_investors: 'No Viewer investors found for this firm.',
        superuser_investor_count_tooltip:
            'As a Superuser, this user has visibility of all investors in the client list page.'
    }
};

export default page;
